import { memo } from 'react';
import * as R from 'ramda';

import { AssetDraftFromPhotoToolOutput } from '@atom/types/ai';

import { ChatAssetDraftProvider } from './ChatAssetDraftContext';
import ChatAssetDraftToolLayout from './ChatAssetDraftToolLayout';

type ChatAssetDraftToolProps = {
  result?: AssetDraftFromPhotoToolOutput;
  toolCallId?: string;
  addResult?: (result: any) => void;
};

const ChatAssetDraftTool = ({
  result,
  toolCallId,
  addResult,
}: ChatAssetDraftToolProps) => (
  <ChatAssetDraftProvider
    toolOutput={result}
    toolCallId={toolCallId}
    addResult={addResult}
  >
    <ChatAssetDraftToolLayout />
  </ChatAssetDraftProvider>
);

export default memo(
  ChatAssetDraftTool,
  (prev, next) =>
    R.equals(prev.result?.result, next.result?.result) &&
    prev.toolCallId === next.toolCallId,
);
